export const getMessageErro = (err: any, defaultErro: string): string => {
  if (err.response?.data?.msg)
    return err.response.data.msg;
  else if (err.message)
    return err.message;
  else
    return defaultErro;
}